import { PRIVACY_URL, USE_BLS_THEME } from '@constants';
import { Box, Link } from '@mui/material';
import { Trans } from 'react-i18next';

import useTheme from '~/theme/ThemeProvider';
import { resolveUrl } from '~/utils/urlUtils';

import ImprintDialog from './ImprintDialog';
import LanguageSwitcher from './LanguageSwitcher';
import SupportDialog from './SupportDialog';

export default function Footer() {
  const appTheme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        gap: 2,
        padding: 3,
        width: '100%',
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        overflow: 'hidden',
        '& a': { color: 'inherit' },
        color: appTheme.colors.TEXT,
        ...(USE_BLS_THEME ? {} : { borderTop: theme => `1px solid ${theme.palette.divider}` }),
        [appTheme.theme.breakpoints.up('md')]: {
          ...(USE_BLS_THEME ? { color: appTheme.colors.FOOTER } : {}),
        },
      }}
    >
      <LanguageSwitcher />
      <ImprintDialog />
      <Link
        href={resolveUrl(PRIVACY_URL)}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ textDecoration: 'underline', textUnderlineOffset: 4, textDecorationThickness: 1 }}
      >
        <Trans i18nKey="footer.privacy" />
      </Link>
      <SupportDialog />
    </Box>
  );
}
